// MODULES
import React from "react";

// COMPONENTS
import FeatherIcon from "@components/FeatherIcon/FeatherIcon";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class CobSectionNumber extends React.PureComponent {
    
    render() {
        const { id, fulfilled, number, sticky, title, limited, hidden } = this.props;

        const index = number - 1;
        const classes = createClassName("Cob-SectionNumber", {
          fulfilled,
          sticky,
          limited,
          hidden
        });
        const circleStyle = {
            top: !sticky ? undefined : (20 * number) + (40 * index),
        };

        return (
            <div ref={ ref => this.containerElement = ref } className={ classes } title={ title }>
                <a className="Cob-SectionNumber-circle" style={ circleStyle } href={ "#" + id }>
                    <div className="Cob-SectionNumber-number">{ number }</div>
                    <FeatherIcon className="Cob-SectionNumber-check" type="check" size={ 18 } strokeWidth={ 3 } />
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/SectionNumber/SectionNumber.js